
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * BinaryOperatorType enum
 */
class BinaryOperatorType {
  /**
   * Initialize enum with a given value
   * @param {BinaryOperatorType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof BinaryOperatorType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!BinaryOperatorType}
   * @param {!BinaryOperatorType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof BinaryOperatorType)) {
      throw new TypeError('Instance of BinaryOperatorType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!BinaryOperatorType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!BinaryOperatorType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === BinaryOperatorType.EQUAL.value) {
      return 'EQUAL'
    }
    if (this.value === BinaryOperatorType.NOT_EQUAL.value) {
      return 'NOT_EQUAL'
    }
    if (this.value === BinaryOperatorType.LESS.value) {
      return 'LESS'
    }
    if (this.value === BinaryOperatorType.LESS_OR_EQUAL.value) {
      return 'LESS_OR_EQUAL'
    }
    if (this.value === BinaryOperatorType.GREATER.value) {
      return 'GREATER'
    }
    if (this.value === BinaryOperatorType.GREATER_OR_EQUAL.value) {
      return 'GREATER_OR_EQUAL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!BinaryOperatorType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!BinaryOperatorType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!BinaryOperatorType} Created enum
   */
  static fromObject (other) {
    return new BinaryOperatorType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
BinaryOperatorType.EQUAL = new BinaryOperatorType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
BinaryOperatorType.NOT_EQUAL = new BinaryOperatorType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
BinaryOperatorType.LESS = new BinaryOperatorType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
BinaryOperatorType.LESS_OR_EQUAL = new BinaryOperatorType(0 + 3)
// noinspection PointlessArithmeticExpressionJS
BinaryOperatorType.GREATER = new BinaryOperatorType(0 + 4)
// noinspection PointlessArithmeticExpressionJS
BinaryOperatorType.GREATER_OR_EQUAL = new BinaryOperatorType(0 + 5)

export { BinaryOperatorType };

/**
 * Fast Binary Encoding BinaryOperatorType field model
 */
class FieldModelBinaryOperatorType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelBinaryOperatorType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelBinaryOperatorType}
   * @param {BinaryOperatorType=} defaults Default value, defaults is new BinaryOperatorType()
   * @returns {!BinaryOperatorType} Result value
   */
  get (defaults = new BinaryOperatorType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new BinaryOperatorType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelBinaryOperatorType}
   * @param {!BinaryOperatorType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelBinaryOperatorType };
